import { useMutation } from "@tanstack/react-query";
import { apiGateway } from "@contexts";
import {
  FormBody,
  FormContentContainer,
  FormHeader,
  FullScreenLoader,
} from "../../../components";
import { Step } from "../../../interfaces";
import { useEffect } from "react";

interface VerifyLoginData {
  payload: { message: string };
}

interface Props {
  setStep: React.Dispatch<React.SetStateAction<Step>>;
}

export const VerifyClaveUnicaLogin: React.FC<Props> = ({ setStep }) => {
  const { mutate } = useMutation({
    mutationFn: () =>
      apiGateway<VerifyLoginData>({
        method: "post",
        url: "/enrolment/clave-unica/verify",
      }),
    onSuccess: () => {
      setStep("ciDocForm");
    },
    onError: () => {
      // TODO: show alert of error and go back after a couple seconds (for this we need the id)
    },
  });
  useEffect(() => {
    // Notice that this will run twice in StricMode :(
    mutate();
  }, [mutate]);

  return (
    <>
      <FormHeader />
      <FormContentContainer flex={1} disableGutters>
        <FormBody justifyContent="center">
          <FullScreenLoader title={"Verificando identidad"} />
        </FormBody>
      </FormContentContainer>
    </>
  );
};
